
import { ArticleData } from "./types";

export const harmfulContentDetection: ArticleData = {
  id: 100,
  slug: "harmful-content-detection",
  title: "Harmful Content Detection",
  author: "Bharathi Thangamani",
  publishDate: "April 18, 2023",
  lastUpdated: "May 8, 2025",
  category: "ML System Design",
  readTime: "12 min read",
  readCount: 10,
  likeCount: 2,
  isPremium: true,
  contentType: "markdown",
  description: "Learn how to design a system for detecting harmful content on social media platforms.",
  tags: ["machine learning", "content moderation", "system design"]
};
